import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateTribeTemplateRequest,
  UpdateTribeTemplateRequest,
  ViewTribeTemplateRequest
} from './tribe-template.types';

export const requestCreateTribeTemplate =
  createAction<SagaPayload<CreateTribeTemplateRequest>['payload']>('request/createTribeTemplate');

export const requestViewTribeTemplate =
  createAction<SagaPayload<ViewTribeTemplateRequest>['payload']>('request/ViewTribeTemplate');

export const requestUpdateTribeTemplate =
  createAction<SagaPayload<UpdateTribeTemplateRequest>['payload']>('request/UpdateTribeTemplate');
